const API_BASE = import.meta.env.VITE_API_BASE ?? '';

function authHeaders() {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getLenguajes() {
  const r = await fetch(`${API_BASE}/api/catalog/lenguajes`);
  if (!r.ok) throw new Error('Error al cargar idiomas');
  return r.json();
}

export async function getCatalog(lenguajeId = 4, testMode = false) {
  const qs = new URLSearchParams({ lenguajeId });
  if (testMode) qs.set('test', '1');
  const r = await fetch(`${API_BASE}/api/catalog?${qs}`, { headers: authHeaders() });
  if (!r.ok) throw new Error('Error al cargar catálogo');
  return r.json();
}

const TEST_TYPES = [
  'libretest',
  'rotacion',
  'priming',
  'memoriaacortopalabras',
  'digitosdirectosinversos',
  'aprendizajesuperficialprofundo',
];

/** Mapeo del tipo usado en el catálogo (camelCase) al path de la API (lowercase). */
export const TYPE_TO_API_PATH = {
  libretest: 'libretest',
  rotacion: 'rotacion',
  priming: 'priming',
  memoriaACortoPalabras: 'memoriaacortopalabras',
  digitosDirectosInversos: 'digitosdirectosinversos',
  aprendizajeSuperficialProfundo: 'aprendizajesuperficialprofundo',
};

export function getTestConfig(typeOrPath, id) {
  const path = TYPE_TO_API_PATH[typeOrPath] ?? (TEST_TYPES.includes(typeOrPath) ? typeOrPath : 'libretest');
  return fetch(`${API_BASE}/api/tests/${path}/${id}`).then((r) => {
    if (!r.ok) throw new Error('Test no encontrado');
    return r.json();
  });
}
